const Input = {
  baseStyle: {
    field: {
      border: '1px solid #C1CCD2',
      borderRadius: '3px',
      padding: '10px 12px',
      _focus: {
        border: '1px solid #A8B8C2',
      },
      _placeholder: {
        color: '#616161',
        fontSize: '14px',
      },
    },
  },
  defaultProps: {
    variant: null,
  },
};

export default Input;
